import { render, staticRenderFns } from "./StageFilesUploader.vue?vue&type=template&id=c20cdcc6&scoped=true&"
import script from "./StageFilesUploader.vue?vue&type=script&lang=js&"
export * from "./StageFilesUploader.vue?vue&type=script&lang=js&"
import style0 from "./StageFilesUploader.vue?vue&type=style&index=0&id=c20cdcc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20cdcc6",
  null
  
)

export default component.exports